import { IsOptional } from 'class-validator';

export class ProvidersFilter {
	@IsOptional()
	providers: string;
}
